/**
 * Role Based Redirect Component
 * Redirects users to appropriate dashboard based on their role
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RoleBasedRedirect = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Redirect QB admin to question bank dashboard
      if (user.role === 'qb_admin') {
        navigate('/admin/question-bank', { replace: true });
      }
      // Super admin goes to admin dashboard (already handled by Dashboard component)
      // Parent, coaching_teacher, child go to regular dashboard (default)
    }
  }, [user, navigate]);

  return children;
};

export default RoleBasedRedirect;
